
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CounterCartDialog extends Serenity.EntityDialog<CounterCartRow, any> {
        protected getFormKey() { return CounterCartForm.formKey; }
        protected getIdProperty() { return CounterCartRow.idProperty; }
        protected getLocalTextPrefix() { return CounterCartRow.localTextPrefix; }
        protected getNameProperty() { return CounterCartRow.nameProperty; }
        protected getService() { return CounterCartService.baseUrl; }
        protected getDeletePermission() { return CounterCartRow.deletePermission; }
        protected getInsertPermission() { return CounterCartRow.insertPermission; }
        protected getUpdatePermission() { return CounterCartRow.updatePermission; }

        protected form = new CounterCartForm(this.idPrefix);
        constructor() {
            super();
        }

        loadEntity(entity: CounterCartRow) {
            super.loadEntity(entity);
            this.form.InvoiceCompanyId.value = '1';
            this.form.CustomerId.change(e => {
                var vcustomerId = this.form.CustomerId.value;

                if (Q.isEmptyOrNull(vcustomerId)) {
                    // this.setProductDetails({});

                }
                else {

                    try {

                        Orders.OrdersService.GetDetail({
                            CustomerId: parseInt(vcustomerId)
                            //      
                        }, response => {
                            this.form.CustomerId.value = this.form.CustomerId.value;
                            this.form.CustomerName.value = response.CustomerName;
                            this.form.CustomerMobile1.value = response.CustomerMobile1;
                            this.form.CustomerMobile2.value = response.CustomerMobile2;
                            this.form.CustomerEmail1.value = response.CustomerEmail1;
                            this.form.CustomerEmail2.value = response.CustomerEmail2;
                            //this.form.Gstin.value = response.GSTIN;

                            /*this.form.ShippingAddress1.value = response.ShippingAddress1;
                            this.form.ShippingAddress2.value = response.ShippingAddress2;
                            this.form.ShippingCity.value = response.City;
                            this.form.ShippingStateId.value = response.State.toString();
                            this.form.ShippingPincode.value = Number(response.Pincode);*/

                            this.form.BillingAddress1.value = response.BillingAddress1;
                            this.form.BillingAddress2.value = response.BillingAddress2;
                            this.form.BillingCity.value = response.BillingCity;
                            this.form.BillingStateId.value = response.BillingState.toString();
                            //this.form.Gstin.value = response.BillingGSTIN;
                            this.form.BillingPincode.value = Number(response.BillingPincode);


                           
                            
                        });


                    } catch (e) {

                    }
                    //Orders.OrdersService.Retrieve2({
                    //    EntityId: id1
                    //}, response => {
                    //        this.seCustomDetails(response.Entity);
                    //});

                    /*Users.FranchiseeService.Retrieve({
                        EntityId: parseInt(vfranchiseeId)
                    }, response => {
                            this.setCustomDetails(response.Entity);
                    });*/

                }

            });
        }

        //onSaveSuccess(response) {
        //    super.onSaveSuccess(response);
        //    debugger;

        //    // Response.CustomData
        //    if (response.CustomData != null) {
        //        var orders = response.CustomData;
        //        const userRoles: { [key: string]: object } = response.CustomData;
        //        const order = response.CustomData[0];

        //        const orderIdValue = userRoles["OrderId"];
        //        const value = orders.OrderId;
        //        //var dlg = new RioERP.Orders.FranchiseeOrdersDialog();
        //        ////var rd = JSON.stringify(value);
        //        //dlg.loadByIdAndOpenDialog(value);
        //        Q.notifySuccess("Order Created Successfully,You can see the details in Orders");
        //        this.dialogClose();
        //        //window.location.
        //    }
        //    else {
        //        Q.notifyError("Order is already created for this cart");
        //        window.location.reload();
        //    }

        //}

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            //buttons.splice(1, 2)
            buttons.push({
                title: Q.text('Convert To Order'),
                cssClass: 'bg-olive',
                icon: 'fa fa-lock text-green',
                onClick: () => {
                    Q.confirm("Are you sure You want to Convert To Order?", () => {

                        var Id = this.entity.Id;
                        CounterCartService.ConvertToOrder({
                            EntityId: Id,
                            Entity: this.entity
                        }, response => {
                            Q.notifySuccess("Order Created Successfully,You can see the details in Orders");
                            this.dialogClose();
                            window.location.reload();
                            // this.re
                        });
                    });

                }
            });



            return buttons;
        }
    }


}